import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col,Popover } from 'antd';
import { QuestionCircleOutlined,DownloadOutlined } from '@ant-design/icons';
import ReactECharts from 'echarts-for-react';
import help from '../../config/help.json';
import { CSVLink } from 'react-csv';


import './analytics.css';


var cc_data;



// const countriesInfo = Object.keys(countrycodeLatlong).map(code =>({code, lat:countrycodeLatlong[code][0], long:countrycodeLatlong[code][1], name: countries[code.toUpperCase()]}))

class FirstPurchaseTotalCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}

	async componentDidUpdate(prevProps) {
	}


	render() {
		const { opensearchFirstPurchaseTotalList, loading, userTheme } = this.props;

		cc_data = opensearchFirstPurchaseTotalList || [];
		cc_data = cc_data.sort((a, b) => a.key - b.key);
		cc_data = cc_data.map(({key, doc_count}) => ({name: key, value: doc_count}));


		const options = {
			tooltip: {
			  trigger: 'item',
			  formatter: '{a} <br/>{b} : {c} ({d}%)'
			},
			legend: {
				type: 'scroll',
			  top: '5%',
			  left: 'center'
			},
			series: [
			  {
				name: 'Total',
				type: 'pie',
				radius: ['40%', '70%'],
				avoidLabelOverlap: false,
				itemStyle: {
				  borderRadius: 10,
				  borderColor: '#fff',
				  borderWidth: 2
				},
				label: {
				  show: false,
				  position: 'center'
				},
				emphasis: {
				  label: {
					show: true,
					fontSize: 40,
					fontWeight: 'bold'
				  }
				},
				labelLine: {
				  show: false
				},
				data: cc_data
			  }
			]
		  };

		

		return (
			<Card className="analyticCard analyticActiveUsersCard">
				<h3 className="title">{`First Time / One Time Purchase (Total%)  `}
				<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='FirstPurchaseTotalCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={cc_data.map(c => ({ plans: c.name , count: c.value }))} target="_blank" filename={"First Time Purchase(Total%).csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
					<Col span={24}>
						<ReactECharts style={{ height: 320, width: '100%' }} theme={userTheme} option={options} notMerge={true} showLoading={loading} loadingOption={{ color: "#74add1" }} />
					</Col>
				</Row>
			</Card>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	opensearchFirstPurchaseTotalList: state.analytics.opensearchFirstPurchaseTotalList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FirstPurchaseTotalCard));
